import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input
} from "@angular/core";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "ta-step",
  templateUrl: "./step.template.html",
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        color: var(--text--default);
      }
      .step-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 32px;
        width: 32px;
        border-radius: 32px;
      }
    `
  ]
})
export class StepComponent {
  @Input()
  label: string;

  @Input()
  idx: number;

  @Input()
  active = false;

  @Input()
  disabled = false;

  @Input()
  completed = false;

  @HostBinding("class.pointer")
  get cursorPointer(): boolean {
    return !this.active && !this.disabled;
  }

  @HostBinding("class.not-allowed")
  get cursorNotAllowed(): boolean {
    return this.disabled;
  }

  @HostBinding("class.opacity--60")
  get showDisabledState(): boolean {
    return this.disabled && !this.active;
  }
}
